/* eslint-disable no-unused-vars */
import React, { FC, memo, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl,
  LinearProgress,
  TextField,
  Typography,
  IconButton
} from '@material-ui/core';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@material-ui/icons/BookmarkOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useUserInfo from 'src/hooks/user/use-user-info';
import { useBranchInfo } from 'src/hooks/branch/use-branch-info';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';
import useQuotationApi from 'src/hooks/quotation-v2/use-quotation-api';
import useQuotation from 'src/hooks/quotation-v2/use-quotation';

const useStyles = makeStyles((theme) => ({
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  bookmarkButton: {
    padding: 4,
    marginLeft: theme.spacing(1)
  }
}));

interface Props {
  isLoading: boolean;
  onChangeBranch?: (branch_id: number) => void;
}

const Component: FC<Props> = ({ isLoading = false, onChangeBranch }) => {
  const classes = useStyles();
  const quotation = useQuotation();
  const {
    favoriteBranch,
    userBranchOptions,
    userBranchIdDefaultOption,
    setFavoriteBranch
  } = useUserInfo();
  const { fetchQuotationProducts, fetchTemplate } = useQuotationApi();
  const {
    selectedBranchID,
    setSelectedBranchID,
    selectQuotationBranchId
  } = quotation;
  const {
    quotationParams,
    setQuotationParams,
    resetQuotation
  } = useQuotationProduct();

  const handleChange = (event: any, newValue: any) => {
    if (newValue) {
      const branch_id = Number(newValue.value);
      setSelectedBranchID(branch_id);
      onChangeBranch?.(branch_id);
      selectQuotationBranchId(branch_id);

      setQuotationParams({ ...quotationParams, branch_id });
      fetchQuotationProducts({ ...quotationParams, branch_id }, true);
      fetchTemplate({ branch_id });
      resetQuotation();
    }
  };

  useEffect(() => {
    setQuotationParams({
      ...quotationParams,
      branch_id: favoriteBranch || userBranchIdDefaultOption
    });
  }, [favoriteBranch, userBranchIdDefaultOption]);

  return (
    <>
      <FormControl fullWidth>
        <Autocomplete
          disabled={isLoading}
          value={
            userBranchOptions.find((b) => b.value === selectedBranchID) || null
          }
          options={userBranchOptions}
          getOptionLabel={(option) => option.name}
          onChange={handleChange}
          renderOption={(option) => (
            <div className={classes.optionContainer}>
              <Typography>{option.name}</Typography>
              <IconButton
                size="small"
                className={classes.bookmarkButton}
                onClick={(e) => {
                  e.stopPropagation();
                  if (favoriteBranch === option.value) {
                    setFavoriteBranch(null);
                  } else {
                    setFavoriteBranch(option.value);
                  }
                }}
              >
                {favoriteBranch === option.value ? (
                  <BookmarkOutlinedIcon color="primary" />
                ) : (
                  <BookmarkBorderOutlinedIcon />
                )}
              </IconButton>
            </div>
          )}
          renderInput={(params) => (
            <TextField
              label={'Branch'}
              {...params}
              variant="outlined"
              placeholder="Select branch"
            />
          )}
        />
      </FormControl>
      {isLoading && <LinearProgress color="primary" />}
    </>
  );
};

export const BranchOptions = memo(Component);
